import {
	GET_CATEGORY_SELECTION_START,
	GET_CATEGORY_SELECTION_SUCCESS,
	GET_CATEGORY_SELECTION_FAIL,
} from 'client/constants';

export function getCategorySelection({ categoryId }) {
	return async dispatch => {
		try {
			dispatch({ type: GET_CATEGORY_SELECTION_START, payload: { categoryId } });

			const ls = window.localStorage;
			const fieldName = `${categoryId}v2`;
			const selection = JSON.parse(ls.getItem(fieldName) || '{ "isSubmitted": false, "selectedItems": [] }');

			dispatch({ type: GET_CATEGORY_SELECTION_SUCCESS, payload: { categoryId, selection } });

			return selection;
		} catch (e) {
			dispatch({ type: GET_CATEGORY_SELECTION_FAIL, payload: e.message });
		}

		return null;
	};
}
